import request from "@/utils/request";

export const getInfoApi = () => request.get("/client/account/info")

export const menusApi = (projectName) => request.get("/client/document/group", { params: { projectName } })
export const documentApi = (groupNames) => request.get("/client/document/list", { params: { groupNames } })
export const contentApi = (id, password) => request.get("/client/document/content", { params: { id, password } })
export const searchApi = (keyword) => request.get("/client/document/search", { params: { keyword } })


export const logoutApi = () => request.get("/client/account/logout")


